// extracted by mini-css-extract-plugin
export var createdDate = "_gi-1";
export var divider = "_gi-2";
export var headerDivider = "_gi-3";
export var messagesCard = "_gi-0";
export var messagesContainer = "_gi-6";
export var messagesContainerWrapper = "_gi-4";
export var showLeftPanelButton = "_gi-8";
export var topButtons = "_gi-7";
export var withPadding = "_gi-5";